import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SelectComponent } from './select.component';
import { NzSpinModule} from 'ng-zorro-antd';

@NgModule({
  imports     : [ CommonModule, FormsModule, NzSpinModule],
  declarations: [  SelectComponent ],
  exports     : [  SelectComponent ]
})

export class SelectModule {
}


